import React from 'react';
import { useHistory } from 'react-router-dom';
import * as func from '../../utils/funcs';

import HeaderTopic from '../../partials/HeaderTopic';

import styles from './UpdateDetails.module.css';
import { completeDetailsUpdate } from '../../api/completeDetailsUpdate';
import { getUserPlayerInfo } from '../../api/getUserPlayerInfo';

function UpdateDetails(props) {
  const { user, setUser, refreshStates } = props;
  const history = useHistory();

  const player = func.userToPlayer(user);

  const [shirtSize, setShirtSize] = React.useState('');
  const [grade, setGrade] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');

  const handleSubmit = async () => {
    setErrorMessage('');

    // Validate required fields
    if (!shirtSize) {
      setErrorMessage('בחר מידת חולצה');
      return;
    }
    if (!grade) {
      setErrorMessage('בחר כיתה');
      return;
    }

    try {
      // Call completeDetailsUpdate API
      await completeDetailsUpdate(player.user.id, shirtSize, grade);

      // Refresh user data
      const updatedUser = await getUserPlayerInfo();
      if (setUser) {
        setUser(updatedUser);
      }

      // Redirect to their city leagues page
      history.push(`/cityleagues/${updatedUser.player.city}`);
    } catch (error) {
      console.error('Error updating details:', error);
      if (error.response?.data) {
        // Handle field-level errors from backend
        const errors = error.response.data;
        if (errors.shirt_size) {
          setErrorMessage('בחר מידת חולצה');
        } else if (errors.grade) {
          setErrorMessage('בחר כיתה');
        } else {
          setErrorMessage('אירעה שגיאה, נסה שוב');
        }
      } else {
        setErrorMessage('אירעה שגיאה, נסה שוב');
      }
    }
  };

  const handleLogout = () => {
    refreshStates();
    history.push('/signin');
  };

  return (
    <div className={styles.updateDetails}>
      <HeaderTopic topic="  עדכון פרטים" />



      <form>
        <h2>עדכון פרטים זריז לפני הגול...</h2>
        <p className={styles.description}>
          על מנת להמשיך, יש לעדכן את הפרטים הבאים:
        </p>

        <select
          name="shirtSize"
          value={shirtSize}
          onChange={(e) => setShirtSize(e.target.value)}
        >
          <option value="" hidden>
            מידת חולצה
          </option>
          <option value="S">S</option>
          <option value="M">M</option>
          <option value="L">L</option>
          <option value="XL">XL</option>
          <option value="XXL">XXL</option>
        </select>

        <select
          name="grade"
          value={grade}
          onChange={(e) => setGrade(e.target.value)}
        >
          <option value="" hidden>
            כיתה
          </option>
          <option value={7}>ז'</option>
          <option value={8}>ח'</option>
          <option value={9}>ט'</option>
          <option value={10}>י'</option>
          <option value={11}>יא'</option>
          <option value={12}>יב'</option>
        </select>

        {errorMessage && (
          <div className={styles.error}>
            {errorMessage}
          </div>
        )}

        <span></span>

        <input
          type="button"
          className="btnLarge"
          value="עדכון פרטים"
          onClick={handleSubmit}
        />
      </form>
    </div>
  );
}

export default UpdateDetails;

